module.exports = __webpack_public_path__ + "img/coingecko.067b2977.png";